<template>
    <ul class="basic-menu-list-ul overflow-auto">
        <li
            v-for="{
                innerSlotName,
                outterSlotName,
                _originalItem,
            } in computedItems"
            :key="_originalItem.name"
            class="basic-menu-list-li"
            @click="emits('click:item', _originalItem.name)"
        >
            <slot
                name="outter:item"
                v-bind="_originalItem"
            >
                <slot
                    :name="outterSlotName"
                    v-bind="_originalItem"
                >
                    <BasicMenuListItem v-bind="_originalItem">
                        <slot
                            name="inner:item"
                            v-bind="_originalItem"
                        >
                            <slot
                                :name="innerSlotName"
                                v-bind="_originalItem"
                            >
                                {{ _originalItem.text }}
                            </slot>
                        </slot>
                    </BasicMenuListItem>
                </slot>
            </slot>
        </li>
    </ul>
</template>

<script lang="ts" setup>
import BasicMenuListItem, {
    type BasicMenuListItemProps,
} from '@molecules/BasicMenu/BasicMenuListItem.vue';

export type BasicMenuListEmits = {
    (e: 'click:item', name: string): void;
};

const emits = defineEmits<BasicMenuListEmits>();

const props = defineProps<{
    items: BasicMenuListItemProps[];
}>();

const computedItems = computed(() => {
    return props.items.map((item, index) => {
        const { name } = item;
        const innerSlotName = `inner:${name}`;
        const outterSlotName = `outter:${name}`;
        return {
            _originalItem: { hasBorder: index !== 0, ...item },
            innerSlotName,
            outterSlotName,
        };
    });
});
</script>

<style lang="scss" scoped></style>
